<grid [dao]="dao" [add]="add" [title]="isModal ? '' : title" [orderBy]="orderBy" [groupBy]="groupBy" [join]="join" [labelAdd]="labelAdd"
  [selectable]="selectable" (select)="onSelect($event)" [hasAdd]="auth.hasPermissionTo('MOD_DEV_TUDO')" [hasEdit]="false">
  <toolbar></toolbar>
  <filter [deleted]="this.auth.hasPermissionTo('MOD_AUDIT_DEL')" [form]="filter" [where]="filterWhere" [submit]="filterSubmit.bind(this)" [clear]="filterClear.bind(this)" [collapseChange]="filterCollapseChange.bind(this)" [collapsed]="!selectable && filterCollapsed">
    <div class="row">
      <input-select #selectResponsaveis label="Responsável" [size]="4" controlName="usuario_id" [control]="filter!.controls.usuario_id" [items]="responsaveis"></input-select>
      <input-datetime [size]="3" datetime label="Início" controlName="inicio_execucao" [control]="filter!.controls.inicio_execucao" labelInfo="Início dos registros"></input-datetime>
      <input-datetime [size]="3" datetime label="Fim" controlName="final_execucao" [control]="filter!.controls.final_execucao" labelInfo="Fim dos registros"></input-datetime>
    </div>
    <div class="row">
      <separator title="Considerar integrações que tenham solicitado atualizações:">
        <div class="d-flex">
          <input-switch scale="small" labelPosition="right" [size]="2" label="todas" controlName="todas" [control]="filter!.controls.todas" (change)="onAtualizacaoTodasChange()"></input-switch>
          <input-switch scale="small" labelPosition="right" [size]="2" label="de Unidades" controlName="atualizar_unidades" [control]="filter!.controls.atualizar_unidades" (change)="onAtualizacaoChange()"></input-switch>
          <input-switch scale="small" labelPosition="right" [size]="2" label="de Servidores" controlName="atualizar_servidores" [control]="filter!.controls.atualizar_servidores" (change)="onAtualizacaoChange()"></input-switch>
          <input-switch scale="small" labelPosition="right" [size]="2" label="de Chefias" controlName="atualizar_gestores" [control]="filter!.controls.atualizar_gestores" (change)="onAtualizacaoChange()"></input-switch>
          <input-switch scale="small" labelPosition="right" [size]="2" label="de Afastamentos" controlName="atualizar_afastamentos" [control]="filter!.controls.atualizar_afastamentos" (change)="onAtualizacaoChange()"></input-switch>
        </div>
      </separator>
    </div>
  </filter>
  <columns>
    <column title="Demandante" [template]="columnDemandante">
      <ng-template let-row="row" #columnDemandante>
        <span> {{row.usuario ? row.usuario.nome : 'Usuário não logado'}} </span>
      </ng-template>
    </column>
<!--     <column title="Enfileiramento" orderBy="enfileiramento" [template]="columnEnfileiramento">
      <ng-template let-row="row" #columnEnfileiramento>
        <span>{{ util.getDateTimeFormatted(row.enfileiramento) }}</span>
      </ng-template>
    </column> -->
    <column title="Início" orderBy="inicio_execucao" [template]="columnInicioExecucao">
      <ng-template let-row="row" #columnInicioExecucao>
        <span>{{ util.getDateTimeFormatted(row.inicio_execucao) }}</span>
      </ng-template>
    </column>
    <column title="Conclusão" orderBy="final_execucao" [template]="columnFinalExecucao">
      <ng-template let-row="row" #columnFinalExecucao>
        <span>{{ util.getDateTimeFormatted(row.final_execucao) }}</span>
      </ng-template>
    </column>
    <column [titleTemplate]="titleUnidades" [template]="columnUnidades">
      <ng-template let-header="header" #titleUnidades>
        Atualização<br>de Unidades
      </ng-template>
      <ng-template let-row="row" #columnUnidades>
        <span>{{ util.getBooleanFormatted(row.atualizar_unidades) }}</span><br>
      </ng-template>
    </column>
    <column [titleTemplate]="titleServidores" [template]="columnServidores">
      <ng-template let-header="header" #titleServidores>
        Atualização<br>de Servidores
      </ng-template>
      <ng-template let-row="row" #columnServidores>
        <span>{{ util.getBooleanFormatted(row.atualizar_servidores) }}</span>
      </ng-template>
    </column>
    <column [titleTemplate]="titleGestores" [template]="columnGestores">
      <ng-template let-header="header" #titleGestores>
        Atualização<br>de Chefias
      </ng-template>
      <ng-template let-row="row" #columnGestores>
        <span>{{ util.getBooleanFormatted(row.atualizar_gestores) }}</span>
      </ng-template>
    </column>
    <column [titleTemplate]="titleAfastamentos" [template]="columnAfastamentos">
      <ng-template let-header="header" #titleAfastamentos>
        Atualização<br>de Afastamentos
      </ng-template>
      <ng-template let-row="row" #columnAfastamentos>
        <span>{{ util.getBooleanFormatted(row.atualizar_afastamentos) }}</span>
      </ng-template>
    </column>
<!--     <column title="Status" [template]="columnStatus">
      <ng-template let-row="row" #columnStatus>
        <span>{{ row.status }}</span>
      </ng-template>
    </column> -->
    <column *ngIf="!selectable" type="options" [dynamicButtons]="dynamicButtons.bind(this)"></column>
  </columns>
  <pagination [rows]="rowsLimit"></pagination>
</grid>
